import React from 'react';
import { renderPrecautions } from './utils';

const SummarySection = ({ summaryData }) => {
  const showHazardImages = new Set(summaryData.hazards.map(h => h.image))
  
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 duration-300">
      <div className="space-y-4">
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">

          {/* Hazards Section */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 duration-300">
            <div className="flex flex-col items-center justify-center space-y-6">
              <h2 className="text-xl font-bold text-gray-800 mb-2">Hazard at a glance</h2>

              {/* Signal Word */}
              {summaryData.signal_word && (
                <div className="w-full flex justify-center mb-4">
                  <div className={`px-8 py-3 rounded-xl text-2xl font-bold ${
                    summaryData.signal_word.toLowerCase() === 'danger' 
                      ? 'bg-red-100 text-red-800 border-2 border-red-400' 
                      : 'bg-yellow-100 text-yellow-800 border-2 border-yellow-400'
                  }`}>
                    {summaryData.signal_word.toUpperCase()}
                  </div>
                </div>
              )}

              {summaryData.hazards && summaryData.hazards.length > 0 ? (
                <div className="w-full space-y-3">

                  {showHazardImages.size > 0 && (
                    <div className="w-full flex flex-wrap justify-center gap-4 mb-4 ">
                      {[...showHazardImages].map((image, index) => (
                        image ? (
                          <img 
                            key={`ghs-image-${index}`}
                            src={image}
                            alt={`GHS Hazard ${index}`}
                            className="w-36 h-auto object-contain"
                          />
                        ) : null
                      ))}
                    </div>
                  )}

                  {summaryData.hazards.map((item, index) => (
                    <div key={index} className="w-full">
                      <div
                        key={`hazard-${index}-${item.code}`}
                        className="px-4 py-3 bg-red-50 text-red-700 rounded-lg text-sm font-medium mb-2 border border-red-200"
                      >
                        {item.code && item.code !== 'UNKNOWN' && !item.code.startsWith('UNKNOWN_') && (
                          <>
                            <span className="font-bold mr-2">{item.code}:</span>
                          </>
                        )}
                        {item.statement}
                      </div>

                      {/* {item.statements?.map((statement, statementIndex) => (
                        <div
                          key={statementIndex}
                          className="px-4 py-3 bg-red-50 text-red-700 rounded-lg text-sm font-medium mb-2 border border-red-200"
                        >
                          {item.code && item.code !== 'UNKNOWN' && !item.code.startsWith('UNKNOWN_') && (
                            <>
                              <span className="font-bold mr-2">{item.code}:</span>
                            </>
                          )}
                          {statement}
                        </div>
                      ))} */}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-full text-center py-8 text-gray-500">
                  No hazard information available
                </div>
              )}
            </div>
          </div>

          {/* Precautions Column */}
          <div className="bg-yellow-100 p-4 rounded-lg">
            <h3 className="text-xl font-bold mb-2 text-yellow-800 text-center">Precautions</h3>
            <div className="">
              {summaryData.precautions.map(({statement}, index) => renderPrecautions(statement))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummarySection;
